import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import type { ThemeTypedColorProps } from "../../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const BadgeRounded = styled.span<{ hasLink?: boolean } & ThemeTypedColorProps>`
    padding: 1px 5px 2px;
    font-size: 1rem;
    line-height: 1.4rem;
    color: ${theme.colors.azure};
    background-color: ${theme.colors.white};
    border-radius: 50%;
    ${({ hasLink }) =>
        hasLink &&
        css`
            cursor: pointer;
        `};
`;

export const SpotlightWrapper = styled.span`
    margin-left: ${theme.space[1]}px;
    line-height: 1.4rem;

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[1]}px;
    }
`;

export const Wrapper = styled.span<SpaceProps>`
    position: relative;
    top: -3px;
    margin-left: ${theme.space[1]}px;
    z-index: 100;
    ${space};

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[1]}px;
    }
`;
